export { default } from './Home24HeroMesAmbienteHTML';
